import axios, { AxiosResponse } from 'axios';
import {
    ApiTokenRequestDto,
    ApiTokenRequestListParams,
    ChangeApiTokenRequestStatusData,
    ExportApiTokenRequestsParams,
    GeneratePublicApiTokenData,
    PageResponse,
} from './types';
import { IPaginationConfig } from '/react4xp/parts/stats-external-admin/stats-external-admin.types';

const ADMIN_TOKEN_REQUEST_URL = '/services/isnaportal/api/admin/token/request';

/**
 * Получить список токенов
 * @param params
 */
export const getPublicApiTokenList = (
    params: IPaginationConfig,
    signal?: AbortSignal
): Promise<AxiosResponse> => {
    return axios.get('/services/isnaportal/api/public-api-token', { params, signal });
};

/**
 * Сгенерировать токен
 * @param data
 */
export const generatePublicApiToken = (
    data: GeneratePublicApiTokenData
): Promise<AxiosResponse> => {
    return axios.post('/services/isnaportal/api/public-api-token', data);
};

/**
 * Заблокировать токен
 * @param id
 */
export const blockPublicApiToken = (id: string): Promise<AxiosResponse> => {
    return axios.post('/services/isnaportal/api/public-api-token/block', { id });
};

/**
 * Разблокировать токен
 * @param id
 */
export const unblockPublicApiToken = (id: string): Promise<AxiosResponse> => {
    return axios.post('/services/isnaportal/api/public-api-token/unblock', { id });
};

/**
 * Удалить токен по taxpayerCode
 * @param taxpayerCode
 */
export const deletePublicApiTokenByTaxpayerCode = (
    taxpayerCode: string
): Promise<AxiosResponse> => {
    return axios.post(
        '/services/isnaportal/api/public-api-token/delete',
        null,
        {
            params: { taxpayerCode },
        }
    );
};

/**
 * Поиск данных налогоплаельщика
 * @param taxpayerCode
 */
export const findTaxpayerData = (taxpayerCode: string): Promise<AxiosResponse> => {
    return axios.get('/services/isnaportal/api/public-api-token/taxpayer-data', {
        params: { taxpayerCode },
    });
};

/**
 * Получить журнал заявок на выдачу API-токена
 */
export const getAdminTokenRequestList = (
    params: ApiTokenRequestListParams,
    signal?: AbortSignal
): Promise<AxiosResponse<PageResponse<ApiTokenRequestDto>>> => {
    return axios.get(`${ADMIN_TOKEN_REQUEST_URL}/list`, { params, signal });
};

/**
 * Получить карточку заявки
 */
export const getAdminTokenRequestById = (
    id: number
): Promise<AxiosResponse<ApiTokenRequestDto>> => {
    return axios.get(`${ADMIN_TOKEN_REQUEST_URL}/${id}`);
};

/**
 * Изменить статус заявки
 */
export const changeAdminTokenRequestStatus = (
    data: ChangeApiTokenRequestStatusData
): Promise<AxiosResponse<ApiTokenRequestDto>> => {
    return axios.post(`${ADMIN_TOKEN_REQUEST_URL}/status`, data);
};

/**
 * Выдать API-токен по согласованной заявке
 */
export const issueAdminTokenRequest = (
    id: number
): Promise<AxiosResponse<ApiTokenRequestDto>> => {
    return axios.post(`${ADMIN_TOKEN_REQUEST_URL}/issue`, { id });
};

/**
 * Выгрузить журнал заявок в Excel
 */
export const exportAdminTokenRequests = (
    params: ExportApiTokenRequestsParams
): Promise<AxiosResponse<Blob>> => {
    return axios.get(`${ADMIN_TOKEN_REQUEST_URL}/export`, {
        params,
        responseType: 'blob',
    });
};

/**
 * Скачать вложение заявки
 */
export const downloadAdminTokenRequestAttachment = (
    requestId: number,
    attachmentId: number
): Promise<AxiosResponse<Blob>> => {
    return axios.get(
        `${ADMIN_TOKEN_REQUEST_URL}/${requestId}/attachment/${attachmentId}`,
        {
            responseType: 'blob',
        }
    );
};
